import { create } from 'zustand';

type UseRoRoFolderStatusState = {
  isFolderStatusPendingRequest?: boolean;
  isFolderStatusDocumentaryIncident?: boolean;
  isFolderStatusDocumentaryIncidentTreated?: boolean;
};

export const useRoRoFolderStatusState = create<UseRoRoFolderStatusState>(() => ({}));
